export default __webpack_public_path__ + "static/media/All.832a870f.png";